export default {
  app: {
    name: "体育博彩",
    full: "后台模板",
    minimized: "BO"
  },
  no_records: "无记录",
  welcome: "欢迎回来，{用户}！",
  login: "登录到您的账号。",
  login_success: "登入成功。",
  relogin: "请重新登录到您的账号。",
  expired: "时域已过期。",
  denied: "没有权限！",
  success: "您已成功完成！",
  select_date_range: "请选择日期",
  permission_denied: "您无权执行此操作！",
  search_by_id_name: "按ID或名称搜索",
  search_by_name: "按名称搜索",
  close: "账号已被关闭。请与您的管理员联系。",
  suspend: "账号已被暂停。 请与您的管理员联系。",
  suspend_alert1: "您的账号已更改为\"仅查看\".",
  suspend_alert2: "请咨询您的上线。",
  freeze: "账号已被冻结。 请与您的管理员联系。",
  account_id_length_error: "无效的账号ID长度。",
  change_user_status_confirm: "您确定要更改账号状态吗？",
  delete_confirm: "您确定要删除 \"{name}\"吗？",
  update_account_status_confirm: "您确定要更新账号状态吗？",
  update_account_status_cancel: "更新账号状态失败。",
  update_account_status_success: "账号状态已成功更新！",
  update_account_password_confirm: "您确定要更新账号密码吗？",
  update_account_password_cancel: "更新账号密码失败。",
  update_account_password_success: "密码更新成功！",
  update_account_security_confirm: "您确定要更新账号安全性吗？",
  update_account_security_cancel: "更新账号安全性失败。",
  update_account_security_success: "账号安全性已成功更新！",
  update_account_authority_confirm: "您确定要更新账号授权吗？",
  update_account_authority_cancel: "更新账号权限失败。",
  update_account_authority_success: "账号权限已成功更新！",
  block_sub_account_confirm: "您确定要封锁子账号吗？",
  block_sub_account_cancel: "封锁子账号失败。",
  block_sub_account_success: "子账号已成功封锁！",
  unblock_sub_account_confirm: "您确定要解封子账号吗？",
  unblock_sub_account_cancel: "解封子账号失败。",
  unblock_sub_account_success: "子账号已成功解封！",
  successful_update_profile: "您已成功更新个人资料。",
  successful_update_security: "您已成功更新安全码。",
  successful_create_account: "您已成功创建新账号。",
  update_platform_settings_confirm: "您确定要更新平台设置吗？",
  update_platform_settings_cancel: "更新平台设置失败。",
  update_platform_settings_success: "平台设置已成功更新！",
  reset_accumulate_win_confirm: "您确定要重置累积赢额上限吗？",
  reset_accumulate_win_cancel: "重置累积赢额上限失败。",
  reset_accumulate_win_success: "累积赢额上限成功重置！",
  parent_platform_disabled: "上线平台设置已被禁用。",
  copy_success: "账号信息已复制到剪贴板。",
  copy_failed: "您的浏览器不支持复制到剪贴板。",
  copy_all_upline: "复制足球HDP(让球)上线至所有运动类型。",
  copy_all_account: "复制足球HDP(让球)账号至所有运动类型",
  copy_all_remaining: "复制足球HDP(让球)保留至所有运动类型。",
  copy_all_min: "复制足球HDP(让球)最低至所有运动类型。",
  copy_all_min_bet: "复制足球最低投注至所有运动类型。",
  copy_all_max_bet: "复制足球最大投注至所有运动类型。",
  copy_all_max_per_match: "复制足球最大单注至所有运动类型。",
  create_secondary_account_success: "辅助账号已成功创建！ 请重新登录。",
  first_sub_account_success: "子账号已成功更新！ 请重新登录。",
  update_account_commission_confirm: "您确定要更新账号佣金吗？",
  update_account_commission_cancel: "更新账号佣金失败。",
  update_account_commission_success: "账号佣金已成功更新！",
  update_account_position_confirm: "您确定要更新账号PT(持仓)吗？",
  update_account_position_cancel: "更新账号PT(持仓)失败。",
  update_account_position_success: "账号PT(持仓)已成功更新。",
  update_account_bet_limit_confirm: "您确定要更新账号投注限额吗？",
  update_account_bet_limit_cancel: "更新账号投注限额失败。",
  update_account_bet_limit_success: "账号投注限额已成功更新！",
  update_account_profile_confirm: "您确定要更新账号资料吗？",
  update_account_profile_cancel: "更新账号资料失败。",
  update_account_profile_success: "账号资料已成功更新！",
  create_new_account_confirm: "您确定要创建新账号吗？",
  create_new_account_cancel: "创建新账号失败。",
  create_new_account_success: "新账号已成功创建！",
  create_sub_account_confirm: "您确定要创建子账号吗？",
  create_sub_account_cancel: "创建子账号失败。",
  create_sub_account_success: "子账号已成功创建！",
  update_sub_account_confirm: "您确定要更新子账号吗？",
  update_sub_account_cancel: "更新子账号失败。",
  update_sub_account_success: "子账号已成功更新！",
  unblock_account_profile_confirm: "您确定要解封账号资料吗？",
  unblock_account_profile_cancel: "解封账号资料失败。",
  unblock_account_profile_success: "账号资料已成功解封！",
  settlement_confirm: "您确定要进行结算吗？",
  settlement_cancel: "结算失败。",
  settlement_success: "结算成功处理！",
  settlement_not_allowed: "今天不允许结算！",
  search_with_working_date: "搜索于工作日。",
  system_error: "系统无法处理您的请求",
  invalid_password: "无效的用户名或密码。",
  invalid_account: "无效账户。",
  block: "您的账号已被封锁。",
  invalid_security_code: "无效的安全码。",
  source_account_id_required: "账号ID不能为空。",
  target_account_id_required: "目标账号ID不能为空。",
  account_id_required: "账号ID不能为空。",
  sub_login_id_required: "登入ID不能为空。",
  account_not_exists: "无效账号。",
  profile_not_exists: "无效账号。",
  account_inactive: "无效账号。",
  not_blocked_account: "有效账号。",
  password_required: "密码不能为空。",
  parent_id_required: "主级ID不能为空。",
  parent_not_exists:"无效账号。",
  invalid_account_type: "无效账号类型。",
  account_exists: "账号已存在。",
  login_id_required: "登入ID不能为空。",
  new_login_id_required: "新登入ID不能为空。",
  login_id_not_exists: "无效的登入ID。",
  invalid_authority_role: "无效角色。",
  profile_inactive: "无效个人资料。",
  secondary_account_exists: "辅助账号已存在。",
  new_login_id_exists: "新登入ID已存在。",
  new_password_required: "新密码不能为空。",
  security_tag_required: "安全标签不能为空。",
  security_code_required: "安全码不能为空。",
  start_date_required: "开始日期不能为空。",
  end_date_required: "结束日期不能为空。",
  start_date_gt_end_date: "开始日期大于结束日期。",
  start_date_greater_end_date: "开始日期大于结束日期。",
  member_id_required: "会员ID不能为空。",
  currency_code_required: "货币代码不能为空。",
  commission_setting_not_exists: "佣金设置不存在。",
  incomplete_account_line: "账号路线不完整。",
  invalid_hdp_package: "无效的HDP(让球)配套。",
  search_id_required: "搜索ID不能为空。",
  profile_id_required: "资料ID不能为空。",
  login_not_exists: "登入ID无效。",
  no_changes: "无检测到更改。",
  start_date_require: "开始日期不能为空。",
  league_id_required: "联赛ID不能为空。",
  sport_type_required: "运动类型不能为空。",
  match_id_required: "赛事ID不能为空。",
  target_login_id_required: "目标登入ID不能为空。",
  parent_account_not_exists: "无效账号。",
  parent_account_inactive: "无效主级账号。",
  parent_profile_not_exists: "无效账号。",
  parent_profile_inactive: "无效主级资料。",
  target_login_id_not_exists: "无效账号。",
  incorrect_parent: "无效主级ID。",
  invalid_session: "无效时域请求。",
  session_expired: "时域已过期。",
  settle_amount_required: "结算金额不能为空。",
  invalid_settle_amount: "无效结算金额。",
  settle_amount_gt_yesterday_balance: "结算金额大于昨天余额。",
  invalid_account_status: "无效账号状态。",
  bet_limit_packages_required: "投注限额配套不能为空。",
  bet_limit_exists: "投注限额已存在。",
  member_bet_limit_package_gt_one: "会员投注限额配套多于一。",
  parent_bet_limit_not_exists: "主级投注限额不存在。",
  account_commission_required: "账号佣金不能为空。",
  commission_setting_exists: "佣金设置已存在。",
  parent_comm_not_exists: "主级佣金设置不存在。",
  exceeded_parent_comm: "超出了主级佣金设置。",
  others_commission_required: "其他佣金设置不能为空。",
  exceeded_parent_1x2: "超出主级的1x2佣金设置。",
  exceeded_parent_other: "超出主级其他佣金设置。",
  hdp_commission_required: "HDP（让球）佣金设置不能为空。",
  exceeded_parent_hdp_a: "超出主级HPD（A）佣金设置。",
  exceeded_parent_hdp_b: "超出主级HPD（B）佣金设置。",
  exceeded_parent_hdp_c: "超出主级HPD（C）佣金设置。",
  exceeded_parent_hdp_d: "超出主级HPD（D）佣金设置。",
  exceeded_parent_hdp_e: "超出主级HPD（E）佣金设置。",
  exceeded_parent_hdp_f: "超出主级HPD（F）佣金设置。",
  exceeded_parent_hdp_g: "超出主级HPD（G）佣金设置。",
  exceeded_parent_hdp_h: "超出主级HPD（H）佣金设置。",
  exceeded_parent_hdp_i: "超出主级HPD（I）佣金设置。",
  exceeded_parent_hdp_j: "超出主级HPD（J）佣金设置。",
  livecasino_upline_pt_required: "[真人娱乐场] 上线PT（持仓）设置不能为空。",
  livecasino_pt_setting_exists: "[真人娱乐场] PT（持仓）设置不能为空。",
  livecasino_parent_pt_not_exists: "[真人娱乐场] 主级PT（持仓）设置不存在。",
  livecasino_parent_min_not_meet: "[真人娱乐场] 与主级最低PT（持仓）不相符。",
  livecasino_exceeded_parent_pt: "[真人娱乐场] 超出主级PT（持仓）设置。",
  livecasino_account_pt_required: "[真人娱乐场] 账号PT（持仓）不能为空。",
  livecasino_upline_remaining_required: "[真人娱乐场] 上线保留PT（持仓）设置不能为空。",
  livecasino_account_min_required: "[真人娱乐场] 账号最低PT（持仓）设置不能为空。",
  livecasino_upline_remaining_gt_account_pt: "[真人娱乐场] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  livecasino_account_min_gt_p: "[真人娱乐场] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  slots_upline_pt_required: "[老虎机] 上线PT（持仓）设置不能为空。",
  slots_pt_setting_exists: "[老虎机] PT（持仓）设置不能为空。",
  slots_parent_pt_not_exists: "[老虎机] 主级PT（持仓）设置不存在。",
  slots_parent_min_not_meet: "[老虎机] 与主级最低PT（持仓）不相符。",
  slots_exceeded_parent_pt: "[老虎机] 超出主级PT（持仓）设置。",
  slots_account_pt_required: "[老虎机] 账号PT（持仓）不能为空。",
  slots_upline_remaining_required: "[老虎机] 上线PT（持仓）设置不能为空。",
  slots_account_min_required: "[老虎机] 账号最低PT（持仓）设置不能为空。",
  slots_upline_remaining_gt_account_pt: "[老虎机] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  slots_account_min_gt_pt: "[老虎机] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  lotto_upline_pt_required: "[乐透] 上线PT（持仓）设置不能为空。",
  lotto_pt_setting_exists: "[乐透] PT（持仓）设置不能为空。",
  lotto_parent_pt_not_exists: "[乐透] 主级PT（持仓）设置不存在。",
  lotto_parent_min_not_meet: "[乐透] 与主级最低PT（持仓）不相符。",
  lotto_exceeded_parent_pt: "[乐透] 超出主级PT（持仓）设置。",
  lotto_account_pt_required: "[乐透] 账号PT（持仓）不能为空。",
  lotto_upline_remaining_required: "[乐透] 上线PT（持仓）设置不能为空。",
  lotto_account_min_required: "[乐透] 账号最低PT（持仓）设置不能为空。",
  lotto_upline_remaining_gt_account_pt: "[乐透] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  lotto_account_min_gt_pt: "[乐透] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  keno_upline_pt_required: "[奇乐] 上线PT（持仓）设置不能为空。",
  keno_pt_setting_exists: "[奇乐] PT（持仓）设置不能为空。",
  keno_parent_pt_not_exists: "[奇乐] 主级PT（持仓）设置不存在。",
  keno_parent_min_not_meet: "[奇乐] 与主级最低PT（持仓）不相符。",
  keno_exceeded_parent_pt: "[奇乐] 超出主级PT（持仓）设置。",
  keno_account_pt_required: "[奇乐] 账号PT（持仓）不能为空。",
  keno_upline_remaining_required: "[奇乐] 上线PT（持仓）设置不能为空。",
  keno_account_min_required: "[奇乐] 账号最低PT（持仓）设置不能为空。",
  keno_upline_remaining_gt_account_pt: "[奇乐] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  keno_account_min_gt_pt: "[奇乐] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  cockfight_upline_pt_required: "[斗鸡] 上线PT（持仓）设置不能为空。",
  cockfight_pt_setting_exists: "[斗鸡] PT（持仓）设置不能为空。",
  cockfight_parent_pt_not_exists: "[斗鸡] 主级PT（持仓）设置不存在。",
  cockfight_parent_min_not_meet: "[斗鸡] 与主级最低PT（持仓）不相符。",
  cockfight_exceeded_parent_pt: "[斗鸡] 超出主级PT（持仓）设置。",
  cockfight_account_pt_required: "[斗鸡] 账号PT（持仓）不能为空。",
  cockfight_upline_remaining_required: "[斗鸡] 上线PT（持仓）设置不能为空。",
  cockfight_account_min_required: "[斗鸡] 账号最低PT（持仓）设置不能为空。",
  cockfight_upline_remaining_gt_account_pt: "[斗鸡] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  cockfight_account_min_gt_pt: "[斗鸡] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  lottery_upline_pt_required: "[彩票] 上线PT（持仓）设置不能为空。",
  lottery_pt_setting_exists: "[彩票] PT（持仓）设置不能为空。",
  lottery_parent_pt_not_exists: "[彩票] 主级PT（持仓）设置不存在。",
  lottery_parent_min_not_meet: "[彩票] 与主级最低PT（持仓）不相符。",
  lottery_exceeded_parent_pt: "[彩票] 超出主级PT（持仓）设置。",
  lottery_account_pt_required: "[彩票] 账号PT（持仓）不能为空。",
  lottery_upline_remaining_required: "[彩票] 上线PT（持仓）设置不能为空。",
  lottery_account_min_required: "[彩票] 账号最低PT（持仓）设置不能为空。",
  lottery_upline_remaining_gt_account_pt: "[彩票] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  lottery_account_min_gt_pt: "[彩票] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  bet_type_required: "投注类型不能为空。",
  schedule_1_to_7_required: "结算日程不能为空。",
  schedule_exists: "结算日程不存在。",
  parent_schedule_not_exists: "主级结算日程不存在。",
  schedule_1_not_available: "星期一结算不可用。",
  schedule_2_not_available: "星期二结算不可用。",
  schedule_3_not_available: "星期三结算不可用。",
  schedule_4_not_available: "星期四结算不可用。",
  schedule_5_not_available: "星期五结算不可用。",
  schedule_6_not_available: "星期六结算不可用。",
  schedule_7_not_available: "星期日结算不可用。",
  credit_limit_required: "信用额度不能为空。",
  member_credit_limit_required: "会员信用额度不能为空。",
  wallet_exists: "账号已存在。",
  member_credit_limit_gt_credit_limit: "会员信用额度大于信用额度。",
  parent_wallet_not_exists: "账号不存在。",
  account_credit_limit_gt_parent: "账号信用额度大于主级信用额度。",
  member_credit_limit_gt_parent: "会员信用额度大于主级信用额度。",
  exceeded_credit_limit: "超出账号信用额度。",
  soccer_min_bet_required: "最低投注不能为空。",
  soccer_max_bet_required: "最大投注不能为空。",
  soccer_max_per_match_required: "最大单注不能为空。",
  soccer_bet_limit_exists: "投注限额已存在。",
  soccer_parent_bet_limit_not_exists: "主级投注限额不存在。",
  soccer_account_min_bet_lt_parent: "账号最低投注低于主级。",
  soccer_account_max_bet_gt_parent: "账号最大投注大于主级。",
  soccer_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  basketball_min_bet_required: "最低投注不能为空。",
  basketball_max_bet_required: "最大投注不能为空。",
  basketball_max_per_match_required: "最大单注不能为空。",
  basketball_bet_limit_exists: "投注限额已存在。",
  basketball_parent_bet_limit_not_exists: "主级投注限额不存在。",
  basketball_account_min_bet_lt_parent: "账号最低投注低于主级。",
  basketball_account_max_bet_gt_parent: "账号最大投注大于主级。",
  basketball_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  tennis_min_bet_required: "最低投注不能为空。",
  tennis_max_bet_required: "最大投注不能为空。",
  tennis_max_per_match_required: "最大单注不能为空。",
  tennis_bet_limit_exists: "投注限额已存在。",
  tennis_parent_bet_limit_not_exists: "主级投注限额不存在。",
  tennis_account_min_bet_lt_parent: "账号最低投注低于主级。",
  tennis_account_max_bet_gt_parent: "账号最大投注大于主级。",
  tennis_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  baseball_min_bet_required: "最低投注不能为空。",
  baseball_max_bet_required: "最大投注不能为空。",
  baseball_max_per_match_required: "最大单注不能为空。",
  baseball_bet_limit_exists: "投注限额已存在。",
  baseball_parent_bet_limit_not_exists: "主级投注限额不存在。",
  baseball_account_min_bet_lt_parent: "账号最低投注低于主级。",
  baseball_account_max_bet_gt_parent: "账号最大投注大于主级。",
  baseball_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  parlay_min_bet_required: "最低投注不能为空。",
  parlay_max_bet_required: "最大投注不能为空。",
  parlay_max_per_match_required: "最大单注不能为空。",
  parlay_bet_limit_exists: "投注限额已存在。",
  parlay_parent_bet_limit_not_exists: "主级投注限额不存在。",
  parlay_account_min_bet_lt_parent: "账号最低投注低于主级。",
  parlay_account_max_bet_gt_parent: "账号最大投注大于主级。",
  parlay_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  esports_min_bet_required: "最低投注不能为空。",
  esports_max_bet_required: "最大投注不能为空。",
  esports_max_per_match_required: "最大单注不能为空。",
  esports_bet_limit_exists: "投注限额已存在。",
  esports_parent_bet_limit_not_exists: "主级投注限额不存在。",
  esports_account_min_bet_lt_parent: "账号最低投注低于主级。",
  esports_account_max_bet_gt_parent: "账号最大投注大于主级。",
  esports_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  others_min_bet_required: "最低投注不能为空。",
  others_max_bet_required: "最大投注不能为空。",
  others_max_per_match_required: "最大单注不能为空。",
  others_bet_limit_exists: "投注限额已存在。",
  others_parent_bet_limit_not_exists: "主级投注限额不存在。",
  others_account_min_bet_lt_parent: "账号最低投注低于主级。",
  others_account_max_bet_gt_parent: "账号最大投注大于主级。",
  others_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  cs_min_bet_required: "最低投注不能为空。",
  cs_max_bet_required: "最大投注不能为空。",
  cs_max_per_match_required: "最大单注不能为空。",
  cs_bet_limit_exists: "投注限额已存在。",
  cs_parent_bet_limit_not_exists: "主级投注限额不存在。",
  cs_account_min_bet_lt_parent: "账号最低投注低于主级。",
  cs_account_max_bet_gt_parent: "账号最大投注大于主级。",
  cs_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  used_credit_gt_credit_limit: "已使用的信用额度大于信用额度。",
  bet_limit_setting_not_exists: "投注限额设置不存在。",
  parent_bet_limit_setting_not_exists: "主级投注限额设置不存在。",
  package_not_exists_in_parent: "主级投注限额配套设置不存在。",
  soccer_bet_limit_setting_not_exists: "足球投注限额设置不存在。",
  soccer_update_interval_violated: "违反更新间隔。",
  basketball_bet_limit_setting_not_exists: "篮球投注限额设置不存在。",
  basketball_update_interval_violated: "违反更新间隔。",
  tennis_bet_limit_setting_not_exists:"网球投注限额设置不存在。",
  tennis_update_interval_violated: "违反更新间隔。",
  baseball_bet_limit_setting_not_exists:"棒球投注限额设置不存在。",
  baseball_update_interval_violated: "违反更新间隔。",
  parlay_bet_limit_setting_not_exists:"混合过关投注限额设置不存在。",
  parlay_update_interval_violated: "违反更新间隔。",
  esports_bet_limit_setting_not_exists:"电子竞技投注限额设置不存在。",
  esports_update_interval_violated: "违反更新间隔。",
  others_bet_limit_setting_not_exists:"其他投注限额设置不存在。",
  others_update_interval_violated: "违反更新间隔。",
  cs_bet_limit_setting_not_exists:"波胆投注限额设置不存在。",
  cs_update_interval_violated: "违反更新间隔。",
  soccer_parent_bet_limit_setting_not_exists: "足球主级投注限额设置不存在。",
  soccer_min_bet_lt_parent: "足球账号最低投注低于主级。",
  soccer_max_bet_gt_parent: "足球账号最大投注大于主级。",
  soccer_max_per_match_gt_parent: "足球账号最大单注大于主级。",
  basketball_parent_bet_limit_setting_not_exists: "篮球主级投注限额设置不存在。",
  basketball_min_bet_lt_parent: "篮球账号最低投注低于主级。",
  basketball_max_bet_gt_parent: "篮球账号最大投注大于主级。",
  basketball_max_per_match_gt_parent: "篮球账号最大单注大于主级。",
  tennis_parent_bet_limit_setting_not_exists: "网球主级投注限额设置不存在。",
  tennis_min_bet_lt_parent: "网球账号最低投注低于主级。",
  tennis_max_bet_gt_parent: "网球账号最大投注大于主级。",
  tennis_max_per_match_gt_parent: "网球账号最大单注大于主级。",
  baseball_parent_bet_limit_setting_not_exists: "棒球主级投注限额设置不存在。",
  baseball_min_bet_lt_parent: "棒球账号最低投注低于主级。",
  baseball_max_bet_gt_parent: "棒球账号最大投注大于主级。",
  baseball_max_per_match_gt_parent: "棒球账号最大单注大于主级。",
  parlay_parent_bet_limit_setting_not_exists: "混合过关主级投注限额设置不存在。",
  parlay_min_bet_lt_parent: "混合过关账号最低投注低于主级。",
  parlay_max_bet_gt_parent: "混合过关账号最大投注大于主级。",
  parlay_max_per_match_gt_parent: "混合过关账号最大单注大于主级。",
  esports_parent_bet_limit_setting_not_exists: "电子竞技主级投注限额设置不存在。",
  esports_min_bet_lt_parent: "电子竞技账号最低投注低于主级。",
  esports_max_bet_gt_parent: "电子竞技账号最大投注大于主级。",
  esports_max_per_match_gt_parent: "电子竞技账号最大单注大于主级。",
  others_parent_bet_limit_setting_not_exists: "电子竞技主级投注限额设置不存在。",
  others_min_bet_lt_parent: "电子竞技账号最低投注低于主级。",
  others_max_bet_gt_parent: "电子竞技账号最大投注大于主级。",
  others_max_per_match_gt_parent: "电子竞技账号最大单注大于主级。",
  cs_parent_bet_limit_setting_not_exists: "波胆主级投注限额设置不存在。",
  cs_min_bet_lt_parent: "波胆账号最低投注低于主级。",
  cs_max_bet_gt_parent: "波胆账号最大投注大于主级。",
  cs_max_per_match_gt_parent: "波胆账号最大单注大于主级。",
  cs_min_bet_lt_soccer: "波胆账号最低投注低于足球。",
  cs_max_bet_gt_soccer: "波胆账号最大投注大于足球。",
  cs_max_per_match_gt_soccer: "波胆账号最大单注大于足球。",
  update_interval_violated: "违反更新间隔。",
  exceeded_parent_others: "超出主级其他佣金设置。",
  exceeded_parent_hdp: "超出主级HDP（让球）投注限额设置。",
  no_information_available: "无有效信息。",
  request_processing: "正在处理请求...",
  new_login_id_format_error: "仅有从a到z和0到9的小写字母可用。",
  account_id_format_error: "仅有从a到z和0到9的小写字母可用。",
  inactive_account: "账号已被关闭/暂停。 请联系运营商。",

  sportsbook_account_pt_gt_92: "超资深代理持仓不能超过92%",
  pending_result: "等待结果",
  insufficient_balance: "余额不足",
  ok: "完成",
  settlement_warning: "警告：如果余额已全部转入，以下突出显示的会员将获得负投注信用，因此，他们损失的金额可能超过给定的信用额。",
  jackpot_alert: "所有单次累积奖池超过 MYR 100,000 (THB 1,000,000), WBET 将承担全部费用。",
  accumulate_alert: "当汇款完毕后，赢额限制将会重新归零。",
  authorityOptionRequired: "Please choose at least one authority",

  add_key_confirm: "Are you sure want to add key?",
  add_key_success: "Key successfully added!",
  update_key_confirm: "Are you sure want to update key?",
  update_key_success: "Key successfully updated!",

  add_ip_confirm: "您确定要添加IP吗？",
  add_ip_success: "IP已成功添加",
  add_ip_cancel: "添加IP失败。",
  delete_ip_confirm: "您确定要删除 \"{ip}\"吗？",
  delete_ip_success: "IP已成功删除!",
  delete_ip_cancel: "删除IP失败!",
  update_ip_whitelist_success: "IP白名单已成功更新！",
  ip_not_exists: "IP不存在。",
  ip_exists: "IP已存在。",
  targetAccountIdContainReservedWord: "Username contain reserved words",
  update_bet_limit_setting: "您确定要更改投注限额吗？",
  update_bet_limit_setting_cancel: "更改投注限额失败。",
  update_bet_limit_succeed: "投注限额已成功更新！",

  update_account_hdp_packages_confirm: "Are you sure want to update account hdp packages?",
  update_account_hdp_packages_cancel: "Update account hdp packages failed.",
  update_account_hdp_packages_success: "Account hdp packages successfully updated!",

  cash_deposit_confirm: "Are you sure want to deposit cash?",
  cash_deposit_cancel: "Deposit cash failed.",
  cash_deposit_success: "Deposit cash successfully updated!",

  cash_withdrawal_confirm: "Are you sure want to withdraw cash?",
  cash_withdrawal_cancel: "Withdraw cash failed.",
  cash_withdrawal_success: "Withdraw cash successfully updated!",

  welcome_to_wbet: "欢迎来到WBET!",
  invalid_parameter: "Invalid parameter.",
  action_by_required: "Action by is required.",
  invalid_action_by: "Invalid action by.",
  invalid_account_id: "Invalid account ID.",
  invalid_profile_id: "Invalid profile ID.",
  session_token_required: "Session token is required.",
  invalid_session_token: "Invalid session token.",
  invalid_target_account_id: "Invalid target account ID.",
  invalid_search_id: "Invalid search ID.",
  invalid_start_date: "Invalid start date.",
  invalid_end_date: "Invalid end date.",
  invalid_page_number: "Invalid page number.",
  invalid_page_size: "Invalid page size.",
  invalid_account_status: "Invalid account status.",
  invalid_soccer_min_bet: "Invalid min bet.",
  invalid_soccer_max_bet: "Invalid max bet.",
  invalid_soccer_max_per_match: "Invalid maximum bet per match.",
  soccer_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  soccer_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_basketball_min_bet: "Invalid min bet.",
  invalid_basketball_max_bet: "Invalid max bet.",
  invalid_basketball_max_per_match: "Invalid maximum bet per match.",
  basketball_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  basketball_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_tennis_min_bet: "Invalid min bet.",
  invalid_tennis_max_bet: "Invalid max bet.",
  invalid_tennis_max_per_match: "Invalid maximum bet per match.",
  tennis_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  tennis_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_baseball_min_bet: "Invalid min bet.",
  invalid_baseball_max_bet: "Invalid max bet.",
  invalid_baseball_max_per_match: "Invalid maximum bet per match.",
  baseball_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  baseball_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_parlay_min_bet: "Invalid min bet.",
  invalid_parlay_max_bet: "Invalid max bet.",
  invalid_parlay_max_per_match: "Invalid maximum bet per match.",
  parlay_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  parlay_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_esports_min_bet: "Invalid min bet.",
  invalid_esports_max_bet: "Invalid max bet.",
  invalid_esports_max_per_match: "Invalid maximum bet per match.",
  esports_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  esports_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_others_min_bet: "Invalid min bet.",
  invalid_others_max_bet: "Invalid max bet.",
  invalid_others_max_per_match: "Invalid maximum bet per match.",
  others_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  others_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_cs_min_bet: "Invalid min bet.",
  invalid_cs_max_bet: "Invalid max bet.",
  invalid_cs_max_per_match: "Invalid maximum bet per match.",
  cs_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  cs_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_passwords: "Invalid password.",
  invalid_account_type: "Invalid account type.",
  invalid_full_name: "Invalid full name.",
  invalid_contact_email: "Invalid contact email.",
  invalid_contact_phone: "Invalid contact phone.",
  invalid_audit_by: "Invalid audit by.",
  invalid_remark: "Invalid remark.",
  target_profile_id_required: "Target profile ID is required.",
  invalid_target_profile_id: "Invalid target profile ID.",
  invalid_sub_login_id: "Invalid sub login ID.",
  invalid_sort_key: "Invalid sort key.",
  invalid_sort_type: "Invalid sort type.",
  invalid_new_login_id: "Invalid new login ID.",
  invalid_new_password: "Invalid new password.",
  invalid_security_tag: "Invalid security tag.",
  invalid_security_code: "Invalid security code.",
  authority_option_required: "Please choose at least one authority.",
  invalid_authority_option: "Invalid authority option.",
  ip_required: "IP is required.",
  invalid_ip: "Invalid IP",
  suffix_required: "Suffix is required.",
  invalid_suffix: "Invalid suffix.",
  type_required: "Type is required.",
  invalid_type: "Invalid type.",
  callbackurl_required: "Callbackurl is required.",
  invalid_callbackurl: "Invalid callbackurl.",
  email_required: "Email is required.",
  invalid_email: "Invalid email.",
  apistatus_required: "Apistatus is required.",
  invalid_apistatus: "Invalid apistatus.",
  invalid_login_id: "Invalid login ID.",
  invalid_loginsource: "Invalid login source.",
  hdp_package_required: "HDP package required.",
  invalid_target_login_id: "Invalid target login ID.",
  status_required: "Status is required.",
  invalid_status: "Invalid status.",
  amount_required: "Amount is required.",
  invalid_amount: "Invalid amount.",
  method_required: "Method is required.",
  invalid_method: "Invalid method.",
  soccer_hdp_upline_pt_required: "HDP upline PT is required.",
  soccer_hdp_account_pt_required: "HDP account PT is required.",
  soccer_hdp_upline_remaining_required: "HDP upline remaining is required.",
  soccer_hdp_account_min_required: "HDP account minimum is required.",
  soccer_hdp_pt_setting_not_exists: "HDP PT setting does not exists.",
  soccer_hdp_parent_pt_not_exists: "HDP parent PT does not exists.",
  soccer_hdp_exceeded_parent_pt: "HDP exceeded parent PT.",
  soccer_hdp_upline_remaining_gt_account_pt: "HDP upline remaining greater than account PT.",
  soccer_hdp_account_min_gt_pt: "HDP account minimum greater than PT",
  soccer_hdp_account_pt_lt_downline: "HDP account PT lower than downline.",

  invalid_soccer_hdp_upline_pt: "Invalid HDP upline PT.",
  soccer_1x2_upline_pt_required: "1x2 upline PT is required.",
  soccer_1x2_account_pt_required: "1x2 account PT is required.",
  soccer_1x2_upline_remaining_required: "1x2 upline remaining is required.",
  soccer_1x2_account_min_required: "1x2 account minimum is required.",
  soccer_1x2_pt_setting_not_exists: "1x2 PT setting does not exists.",
  soccer_1x2_parent_pt_not_exists: "1x2 parent PT does not exists.",
  soccer_1x2_exceeded_parent_pt: "1x2 exceeded parent PT.",
  soccer_1x2_upline_remaining_gt_account_pt: "1x2 upline remaining greater than account PT.",
  soccer_1x2_account_min_gt_pt: "1x2 account minimum greater than PT",
  soccer_1x2_account_pt_lt_downline: "1x2 account PT lower than downline.",
  
  invalid_soccer_1x2_upline_pt: "Invalid 1x2 upline PT.",
  soccer_others_upline_pt_required: "Others upline PT is required.",
  soccer_others_account_pt_required: "Others account PT is required.",
  soccer_others_upline_remaining_required: "Others upline remaining is required.",
  soccer_others_account_min_required: "Others account minimum is required.",
  soccer_others_pt_setting_not_exists: "Others PT setting does not exists.",
  soccer_others_parent_pt_not_exists: "Others parent PT does not exists.",
  soccer_others_exceeded_parent_pt: "Others exceeded parent PT.",
  soccer_others_upline_remaining_gt_account_pt: "Others upline remaining greater than account PT.",
  soccer_others_account_min_gt_pt: "Others account minimum greater than PT",
  soccer_others_account_pt_lt_downline: "Others account PT lower than downline.",

  invalid_soccer_others_upline_pt: "Invalid others upline PT.",
  parlay_upline_pt_required: "Parlay upline PT is required.",
  parlay_account_pt_required: "Parlay account PT is required.",
  parlay_upline_remaining_required: "Parlay upline remaining is required.",
  parlay_account_min_required: "Parlay account minimum is required.",
  parlay_pt_setting_not_exists: "Parlay PT setting does not exists.",
  parlay_parent_pt_not_exists: "Parlay parent PT does not exists.",
  parlay_exceeded_parent_pt: "Parlay exceeded parent PT.",
  parlay_upline_remaining_gt_account_pt: "Parlay upline remaining greater than account PT.",
  parlay_account_min_gt_pt: "Parlay account minimum greater than PT",
  parlay_account_pt_lt_downline: "Parlay account PT lower than downline.",

  invalid_parlay_upline_pt: "Invalid parlay upline PT .",
  invalid_member_id: "Invalid member ID.",
  invalid_sport_type: "Invalid sport type.",
  invalid_league_id: "Invalid league ID.",
  invalid_match_id: "Invalid match ID.",
  working_date_required: "Working date is required.",
  invalid_working_date: "Invalid working date.",
  game_type_required: "Game type is required.",
  invalid_game_type: "Invalid game type.",
  bet_id_required: "Bet ID is required.",
  invalid_bet_id: "Invalid bet ID.",
  hdp_packages_not_exists: "HDP package does not exists.",
  parent_hdp_packages_not_exists: "Parent HDP package does not exists.",
  invalid_bet_type: "Invalid bet type.",
  invalid_match_id: "Invalid Match ID.",
  invalid_home_running_score: "Invalid Home Running Score.",
  invalid_away_running_score: "Invalid Away Running Score.",
  invalid_home_away: "Invalid Home Away.",

  operator_account_not_exists: "Operator account does not exists.",
  insert_main_failed: "Insert main failed.",
  delete_child_failed: "Delete child failed.",
  insert_child_failed: "Insert child failed.",
  invalid_operator: "Invalid operator.",
  invalid_master: "Invalid master.",
  duplicate_suffix: "Duplicate suffix.",
  insert_error: "Insert error.",
  allow_to_add_multiple_ip: "Allow to add multiple IP, eg. 192.168.1.1,192.168.1.2",
  only_allow_proper_url: "URL must be start with http or https, eg. https://xxxxxx.com",

  password_length_error: "密码必须至少8个字符。",
  password_whitespace_error: "密码不能包含前导或尾随空格。",
  password_types_error: "密码必须至少包含3种字符类型。",
  password_consecutive_error: "密码不能包含连续的字符/数字。",
  password_repeated_error: "密码不能包含重复的字符。",
  password_common_error: "密码不能包含常见单词。",
  
  security_code_required: "安全码是必需的。",
  security_code_error: "安全码必须正好6位数字。",
  security_digit_error: "安全码必须至少包含2个不同的数字。",
  security_consecutive_error: "安全码不能包含连续数字。",
  security_repeated_error: "安全码不能包含重复模式。",
  security_palindrome_error: "安全码不能是回文。",
  security_weak_error: "安全码强度太弱。",

  // OTP 2FA Messages
  other_authenticator_apps_supported: "其他双因素身份验证应用程序（如Sophos、Microsoft Authenticator等）也受支持",
  date_time_automatic_required: "您设备上的日期和时间设置必须设置为自动。",
  get_otp_2fa_qr_code_failed: "获取OTP 2FA QR码失败。请重试。",
  enter_secret_manually: "在您的身份验证应用中手动输入此密钥",
  otp_setup_failed: "设置OTP失败。请重试。",
  otp_verification_failed: "验证码无效。请重试。",
  otp_2fa_bound: "Google Authenticator已成功绑定到您的账户。",
  invalid_code: "验证码无效。请检查验证码并重试。",
  code_required: "请输入6位验证码。",
  otp_unbind_success: "OTP已成功解除绑定。",
  otp_unbind_failed: "解除OTP 2FA失败。请重试。",
};
